import * as React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import * as paths from '../../common/paths';

import { 
  FetchCaptchaResponseVO, 
  LoginProps, LoginRequestVO, LoginStates, 
  LoginUserVO, 
  ResultResponseVO, VerificationSigRequestVO,
} from './typing';

import { Form, Input, Button, Row, Col, Checkbox, FormInstance, Modal, Alert, Spin } from 'antd';
import LOGIN_MESSAGE_KEY from '../../common/lang/login-message-key';
import { Footer } from 'antd/lib/layout/layout';
import * as loginAction from './action/login';
import { FetchCaptchaRequestVO } from './typing';
import UserAgrement from './component/user-agreement'
import PrivacyStrategy from './component/privacy-strategy';
import storage from '../../services/storage';
import { injectIntl } from 'react-intl';
import { InfoCircleOutlined, WarningFilled } from '@ant-design/icons';
require('./index.scss');

/**
 * 用户登录界面的Component
 * 
 * @author Jiawei Chen
 * @since 18/5/2022
 */
class Login extends React.PureComponent<LoginProps, LoginStates> {
  constructor(props) {
    super(props);
    this.state = {
      captchaLoading: false,
      captchaBtnDiasbled: false,
      captchaBtnTxt: this.fmtMessage(LOGIN_MESSAGE_KEY.GET_CAPTCHA_BUTTON),
      errorFromServer: '',
      needIntelligentVerification: false,
      loginBtnDisabled: true,
      isTermChecked: false,
      loginLoading: false,
      dialogShowed: false,
      isCaptchaSent: false,
    };
    this.form = React.createRef();
    let { smartCaptcha, NVC_Opt } = window as any;
    this.smartCaptcha = smartCaptcha;
    this.NVC_Opt = NVC_Opt;
  }

  /**
   * 格式化message
   * @param id message 的 id
   * @param params message 中的要格式化的参数名
   * @returns 
   */
	private fmtMessage = (id, params = {}) => {
    const { intl } = this.props;
    return intl.formatMessage({id}, params);
  };

  // 记录卡号的变量
  private adaNumber: string = '';
  // 记录电话号码的变量
  private phoneNumber: string = '';
  // 记录用户输入的验证码
  private captcha: string = '';
  // 记录验证码对应的token
  private captchaToken: string = '';

  // 记录服务器返回的错误信息
  private errorFromServer: string = '';
  // 智能验证签名记录对象
  private verificationSigRequestVO: VerificationSigRequestVO;
  // From对象
  private form: any;
  // 阿里验证码的创建类
  private smartCaptcha: any;
  // 阿里云验证码的配置对象
  private NVC_Opt: any;
  // 阿里云验证码对象，类型为 smartCaptcha
  private sc: any;

  // 验证码发送成功后的消息
  private captchaSentMsg: string = '';

  /**
   * 控件mount后执行
   */
  componentDidMount () {
    // 初始化智能验证控件
    this.initIntelligentVerification();
  }

  /**
   * 用户点击获取验证码触发方法
   */
  private onFetchCaptchaClick = async () => {
    this.clearServerError();
    // 校验 卡号，电话号码 及 用户协议及私隐策略 是否都已经填写好
    const valid = await this.validateForm(['ada', 'phoneNumber', 'termChecked']);
    if (valid) {
      this.setState({
        captchaLoading: true,
        isCaptchaSent: false,
      }, this.doFetchCaptcha);
    }
  };

  /**
   * 获取验证码操作
   */
  private doFetchCaptcha = () => {
    let fetchCaptchaRequestVO: FetchCaptchaRequestVO = {
      adaNumber: this.adaNumber,
      phoneNumber: this.phoneNumber,
      intVerificationResult: this.verificationSigRequestVO,
    };
    loginAction.fetchCaptcha(fetchCaptchaRequestVO)
      .then((response: ResultResponseVO) => {
        if (response.code !== '0') {
          this.errorFromServer = response.message;
          // 清空智能认证对象
          this.verificationSigRequestVO = null;
          this.setState({
            captchaLoading: false,
          }, () => this.validateForm(['ada', 'phoneNumber', 'termChecked']));
        } else {
          // 清空错误信息
          this.errorFromServer = '';
          // 校验表单
          this.validateForm(['ada', 'phoneNumber', 'termChecked']);
          
          let captchaResponse: FetchCaptchaResponseVO = response.data;
          // 如果需要智能验证
          if (captchaResponse && captchaResponse.needIntelligentVerification) {
            this.setState({ 
              needIntelligentVerification: true, 
              captchaBtnDiasbled: true,
              captchaLoading: false,
              captchaBtnTxt: this.fmtMessage(LOGIN_MESSAGE_KEY.INTELLIGENT_VERIFICATION_BUTTON),
            }, this.reloadIntelligentVeririfcation);
          } else {
            // 清空智能认证对象
            this.verificationSigRequestVO = null;
            // 记录验证码的token
            this.captchaToken = captchaResponse.captchaToken;
            // 提示用户短信已经发送
            this.afterCaptchaSend();
            // 验证码发送后的提示信息
            this.captchaSentMsg = captchaResponse.sentMessage;
            this.toggleCaptchaSentMsg();
          }
        }
      }).catch(err => {
        if (err && err.response && err.response.status == 403 && err.response.data.message) {
          this.errorFromServer = err.response.data.message;
        } else {
          this.errorFromServer = this.fmtMessage(LOGIN_MESSAGE_KEY.NETWORK_ERROR);
        }
        this.setState({
          captchaLoading: false,
        }, this.validateForm);
      });
  };

  /**
   * 用户获取验证码后，设置倒数，提示用户可在指定时间后再次尝试获取验证码
   */
  private afterCaptchaSend = () => {
    let times = 60;
    var int = setInterval(() => {
      if (times > 0) {
        this.setState({
          captchaLoading: false,
          captchaBtnDiasbled: true,
          captchaBtnTxt: this.fmtMessage(LOGIN_MESSAGE_KEY.RE_GET_CAPTCHA_BUTTON, {times}),
        });
      }
      times--;
    }, 1000);
    setTimeout(() => {
      clearInterval(int);
      this.setState({
        captchaLoading: false,
        captchaBtnDiasbled: false,
        captchaBtnTxt: this.fmtMessage(LOGIN_MESSAGE_KEY.GET_CAPTCHA_BUTTON),
      });
    }, times * 1000);
  }

  /**
   * 执行Ajax操作，服务器返回错误信息的校验器
   * @param rule 规则对象
   * @param value 控件值
   * @param callback 回调方法
   */
  private serviceErrorValidator = (rule, value, callback) => {
    const { field } = rule;
    if (this.errorFromServer) {
      const errorMsgArr = this.errorFromServer.split('#');
      const errorPrifix = errorMsgArr[0];
      const errorMsg = errorMsgArr[1];
      if (field === errorPrifix) {
        callback(this.getErrorMsg(errorMsg));
      } else if(!errorMsg && field === 'login') {
        callback(this.getErrorMsg(this.errorFromServer))
      }
    } else {
      callback();
    }
  };

  /**
   * 用于validator校验服务器信息后展示错误信息
   * @param message 信息字符串
   * @returns 
   */
  private getErrorMsg = (message: string): any => {
    return <Alert showIcon={true} icon={<WarningFilled style={{fontSize: 18}} />} message={message} type="warning" />
  }

  /**
   * 校验表单
   * @returns 校验是否通过
   */
  private validateForm = async (fields?: Array<string>) => {
    const formInstance = this.form.current as FormInstance;
    try {
      if (fields) {
        await formInstance.validateFields(fields);
      } else {
        await formInstance.validateFields();
      }
      return true;
    } catch (errorInfo) {
      return false;
    }
  };

  /**
   * ada控件输入变化时触发
   * @param e event对象
   */
  private onAdaNumberChange = e => {
    this.clearServerError();
    // this.validateForm(['ada']);
    this.adaNumber = e.target.value;
    this.setLoginBtnState();
  };

  /**
   * 电话号控件输入变化时触发
   * @param e event对象
   */
  private onPhoneNumberChange = e => {
    this.clearServerError();
    this.phoneNumber = e.target.value;
    this.setLoginBtnState();
  };

  /**
   * 验证码控件输入变化时触发
   * @param e event对象
   */
  private onCaptchaChange = e => {
    this.clearServerError();
    this.captcha = e.target.value;
    this.setLoginBtnState();
  };

  /**
   * 点击登录按钮触发
   */
  private onLoginClicked = async() => {
    this.errorFromServer = '';
    let valid: boolean = await this.validateForm();
    if (valid) {
      this.setState({
        loginLoading: true,
      }, this.processLogin);
    }
  };

  /**
   * 登录操作过程
   */
  private processLogin = () => {
    this.errorFromServer = '';
    const { captcha, captchaToken, adaNumber, phoneNumber } = this;
    let loginRequestVO: LoginRequestVO = {
      captcha, captchaToken, adaNumber, phoneNumber,
    };
    loginAction.loginPyxis(loginRequestVO).then((response: ResultResponseVO) => {
      if (response.code !== '0') {
        this.errorFromServer = response.message;
        this.setState({
          loginLoading: false,
          isCaptchaSent: false,
        }, this.validateForm);
      } else {
        // 清空登录错误信息
        this.errorFromServer = '';
        this.setState({
          loginLoading: false,
        }, () => this.loginSuccessfully(response.data));
      }
    }).catch(err => {
      if (err && err.response && err.response.status == 403 && err.response.data) {
        this.errorFromServer = err.response.data.message;
      } else {
        this.errorFromServer = this.fmtMessage(LOGIN_MESSAGE_KEY.NETWORK_ERROR);
      }
      this.setState({
        loginLoading: false,
        isCaptchaSent: false,
      }, this.validateForm);
    });
  };

  /**
   * 登录成功后的操作
   * (1) 把服务器返回的用户信息保存到 storage
   * (2) 如果用户未同意公告，则跳去公告页
   * (3) 如果用户已同意公告，则跳去pyxis desktop 页
   */
  private loginSuccessfully = (data: LoginUserVO) => {
    // 校验表单
    this.validateForm();
    // 保存用户信息到 local storage
    storage.setUserInfo(data);
    if (!data.announcementInfo || data.announcementInfo.agreed) {
      this.props.history.push({pathname: paths.PYXIS_PATH});
    } else {
      this.props.history.push({pathname: paths.ANNOUNCEMENT_PATH});
    }
  };

  /**
   * 设置登录按钮的状态
   */
  private setLoginBtnState = () => {
    let loginBtnDisabled = !this.captcha || !this.adaNumber || !this.phoneNumber;
    this.setState({ loginBtnDisabled });
  };

  /**
   * 初始化智能验证控件
   */
  private initIntelligentVerification = () => {
    let loginComponent = this;
    if (this.smartCaptcha) {
      this.sc= new this.smartCaptcha({
        renderTo: '#sc',
        width: '100%',
        height: 42,
        default_txt: this.fmtMessage(LOGIN_MESSAGE_KEY.START_INTELLIGENT_VERIFICATION_TIPS),
        success_txt: this.fmtMessage(LOGIN_MESSAGE_KEY.SUCCESS_INTELLIGENT_VERIFICATION_TIPS),
        fail_txt: this.fmtMessage(LOGIN_MESSAGE_KEY.FAIL_INTELLIGENT_VERIFICATION_TIPS),
        scaning_txt: this.fmtMessage(LOGIN_MESSAGE_KEY.SCANING_INTELLIGENT_VERIFICATION_TIPS),
        success: function(data) {
          loginComponent.verificationSigRequestVO = {
            sessionId: data.sessionId,
            token: loginComponent.NVC_Opt.token,
            sig: data.sig,
          };
          loginComponent.afterIntelligentVerification();
        },
        fail: function(data) {
        loginComponent.afterIntelligentVerification();
        }
      });
      this.sc.init();
    }
  };

  /**
   * 刷新智能验证控件
   */
  private reloadIntelligentVeririfcation = () => {
    if (this.sc && this.sc.clicked) {
      this.sc.reset();
    }
  };

  /**
   * 智能验证控件初始化后操作
   */
  private afterIntelligentVerification = () => {
    this.setState({
      captchaLoading: false,
      captchaBtnDiasbled: false,
      captchaBtnTxt: this.fmtMessage(LOGIN_MESSAGE_KEY.GET_CAPTCHA_BUTTON),
    });
  };

  /**
   * 显示对话框
   * @param event 
   * @param dialogType 用户协议 或 私隐策略
   */
  private showDialog = (event, dialogType): any => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({
      dialogShowed: true,
      dialogType: dialogType,
    });
  };

  /**
   * 关闭窗体
   */
  private closeDialog = () => {
    this.setState({
      dialogShowed: false,
    });
  };

  /**
   * 清除来自服务器的错误信息
   */
  private clearServerError = () => {
    this.errorFromServer = '';
  };

  /**
   * 设置发送验证码信息
   */
  private toggleCaptchaSentMsg = () => {
    const { isCaptchaSent } = this.state;
    this.setState({
      isCaptchaSent: !isCaptchaSent,
    });
  }

  render() {
    const { 
      captchaLoading, captchaBtnDiasbled, captchaBtnTxt, 
      needIntelligentVerification, 
      loginBtnDisabled, loginLoading,
      dialogShowed, dialogType, isCaptchaSent,
    } = this.state;
    const modalTitle = dialogType === 'privacy-strategy'? 
      this.fmtMessage(LOGIN_MESSAGE_KEY.TERM_DESCRIPTION_PRIVACY_STRATEGY) : this.fmtMessage(LOGIN_MESSAGE_KEY.TERM_DESCRIPTION_USER_AGREEMENT);

    const termEle = this.fmtMessage(LOGIN_MESSAGE_KEY.TERM_DESCRIPTION, {
      userAg: <Button id="btnUserAgree" key='btn-user-agreement' type='link' onClick={e => this.showDialog(e, 'user-agreement')} className='term-button'>《{this.fmtMessage(LOGIN_MESSAGE_KEY.TERM_DESCRIPTION_USER_AGREEMENT)}》</Button>,
      privacyStrategy: <Button id="btnPrivacyStrategy" key='privacy-strategy' type='link' onClick={e => this.showDialog(e, 'privacy-strategy')} className='term-button'>《{this.fmtMessage(LOGIN_MESSAGE_KEY.TERM_DESCRIPTION_PRIVACY_STRATEGY)}》</Button>
    });

    return (
      <div className='bg login-page'>
        <div className='fill-container' />
        <div className='top_decorate'>
          <div>{this.fmtMessage(LOGIN_MESSAGE_KEY.LOGIN_TITLE)}</div>
          <div>{this.fmtMessage(LOGIN_MESSAGE_KEY.LOGIN_SUB_TITLE)}</div>
        </div>
        <div className='login_card'>
          <div className='left_decorate'>
            <div>{this.fmtMessage(LOGIN_MESSAGE_KEY.LOGIN_TITLE)}</div>
            <div>{this.fmtMessage(LOGIN_MESSAGE_KEY.LOGIN_SUB_TITLE)}</div>
          </div>
          <div className='login_form'>
            <Form
              name="basic"
              wrapperCol={{ span: 24 }} initialValues={{ remember: true }}
              autoComplete="off" ref={this.form}
            >
              <Row>
                <Col span={24}>
                  <div className='form-title ant-row ant-form-item'>
                    {this.fmtMessage(LOGIN_MESSAGE_KEY.LOGIN_FORM_TITLE)}
                  </div>
                </Col>
              </Row>
              {/* 卡号输入框 */}
              <Form.Item
                name="ada"
                rules={[
                  { required: true, message: this.getErrorMsg(this.fmtMessage(LOGIN_MESSAGE_KEY.ADA_NUMBER_REQUIRED_ERROR)) },
                  { validator: this.serviceErrorValidator },
                ]}
              >
                <Row>
                  <Col span={24}>
                    <Input placeholder={this.fmtMessage(LOGIN_MESSAGE_KEY.ADA_TEXTBOX_PLACEHOLDER)} maxLength={14} onChange={this.onAdaNumberChange} />
                  </Col>
                </Row>
              </Form.Item>
              {/* 手机号输入框 */}
              <Form.Item
                name="phoneNumber"
                rules={[
                  { required: true, message: this.getErrorMsg(this.fmtMessage(LOGIN_MESSAGE_KEY.PHONE_NUMBER_REQUIRED_ERROR)) },
                  { validator: this.serviceErrorValidator },
                ]}
              >
                <Row>
                  <Col span={24}>
                    <Input placeholder={this.fmtMessage(LOGIN_MESSAGE_KEY.PHONE_NUMBER_TEXTBOX_PLACEHOLDER)} maxLength={14} onChange={this.onPhoneNumberChange} />
                  </Col>
                </Row>
              </Form.Item>
              {/* 验证码输入框 */}
              <Form.Item
                name="captcha"
                rules={[
                  { required: true, message: this.getErrorMsg(this.fmtMessage(LOGIN_MESSAGE_KEY.CAPTCHA_REQUIRED_ERROR)) },
                  { validator: this.serviceErrorValidator }
                ]}
              >
                <Row>
                  <Col span={24}>
                    <Input placeholder={this.fmtMessage(LOGIN_MESSAGE_KEY.CAPTCHA_TEXTBOX_PLACEHOLDER)}  maxLength={6} onChange={this.onCaptchaChange} />
                  </Col>
                  <div style={{ position: 'absolute', right: '8px', top: '8px' }}>
                    <Button
                      type="link" className='fetch-captcha-btn'
                      loading={captchaLoading} disabled={captchaBtnDiasbled}
                      onClick={this.onFetchCaptchaClick}>{captchaBtnTxt}</Button>
                  </div>
                </Row>
              </Form.Item>
              {/* 验证码发送成功后显示的提示 */}
              <Form.Item hidden={!isCaptchaSent}>
                <Row>
                  <Col span={24}>
                    <Alert showIcon={true} icon={<InfoCircleOutlined style={{fontSize: 14}} />} message={this.captchaSentMsg} type="info" className='captcha-sent-msg' />
                  </Col>
                </Row>
              </Form.Item>
              {/* 智能验证，当用户输入错误的验证码过多要显示 */}
              <Form.Item hidden={!needIntelligentVerification}>
                <Row>
                  <Col span={24}>
                    <div id="sc" />
                  </Col>
                </Row>
              </Form.Item>
              {/* 用户协议 及 私隐政策 */}
              <Form.Item className='term-item' name="termChecked"
                getValueProps={ value => ({ checked: value === 'yes', value }) }
                getValueFromEvent={ e => e.target.checked ? 'yes' : '' }
                rules={[
                  { required: true, message: this.getErrorMsg(this.fmtMessage(LOGIN_MESSAGE_KEY.TERM_REQUIRED_ERROR)) },
                ]}
              >
                <Row>
                  <Col span={24}>
                    <Checkbox>{termEle}</Checkbox>
                  </Col>
                </Row>
              </Form.Item>
              {/* 登录按钮 */}
              <Form.Item
                name="login"
                rules={[
                  { validator: this.serviceErrorValidator }
                ]}
              >
                <Row>
                  <Col span={24}>
                    <Button type="primary" htmlType="button" 
                      onClick={this.onLoginClicked} block disabled={loginBtnDisabled} 
                      loading={loginLoading} className='login-button'
                    >{this.fmtMessage(LOGIN_MESSAGE_KEY.LOGIN_BUTTON)}</Button>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </div>
        </div>
        <div className='fill-container' />
        {/* 页面底部的 copyright 信息 */}
        <Footer className='footer' dangerouslySetInnerHTML={{ __html: this.fmtMessage(LOGIN_MESSAGE_KEY.COPYRIGHT_DESCRIPTION)}}></Footer>
        {/* 显示 用户协议 或 私隐策略 的窗口 */}
        <Modal 
          visible={dialogShowed} closable={false} title={modalTitle}
          className='user-degreement-dialog'
          footer={[
            <Button id="btnCloseModal" key="close" className='close-btn' onClick={this.closeDialog}>
              {this.fmtMessage(LOGIN_MESSAGE_KEY.CLOSE_BUTTON)}
            </Button>]}>
          {dialogType === 'privacy-strategy'? <PrivacyStrategy /> : <UserAgrement />}
        </Modal>
      </div>
    );
  }
}

(Login as React.ComponentType).defaultProps = {
  loading: true,
  location: { pathname: '' },
};

(Login as React.ComponentType<any>).contextTypes = {
  numeric: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(withRouter(Login));
